var _linearGradient, _linearGradient2, _linearGradient3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 153.108,
    height: 44.837,
    viewBox: "0 0 153.108 44.837",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lly0ksy0sa",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8940"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "om3ricrqmc",
    x1: 0,
    x2: 1,
    xlinkHref: "#lly0ksy0sa"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "37krih9k0d",
    x1: 0.166,
    y1: 0.175,
    x2: 0.851,
    y2: 0.865,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff7ad"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "dvh9838zwb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 38466",
    style: {
      fill: "none"
    },
    d: "M0 0h32.229v40.786H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7h4h3heeje"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 38565",
    style: {
      fill: "none"
    },
    d: "M0 0h95.674v15.32H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "uyswc6verf"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 38566",
    style: {
      fill: "none"
    },
    d: "M0 0h44.56v15.322H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Launcher icon",
    transform: "translate(.766 3.43)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 40840"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 40839",
    style: {
      clipPath: "url(#dvh9838zwb)"
    },
    transform: "translate(2.89)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 13890",
    d: "M30.516 21.764a4.082 4.082 0 0 0-5.621 1 9.3 9.3 0 1 1-.408-11.373 3.985 3.985 0 0 0 4.626 1.167 4.036 4.036 0 0 0 1.567-6.309A17.341 17.341 0 1 0 5.861 30.33l10.11 9.944a1.782 1.782 0 0 0 2.488.012l9.674-9.335h-.039a17.322 17.322 0 0 0 3.39-3.558 4.025 4.025 0 0 0-.967-5.628",
    style: {
      fill: "#ffe500"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 13889",
    d: "M24.316-10 5.673-5.718A6.213 6.213 0 0 0 5.466 6.64L24.316 11a1.294 1.294 0 0 0 1.294-1.292V-8.706A1.294 1.294 0 0 0 24.316-10",
    transform: "translate(14.39 17.259)",
    style: {
      opacity: 0.7,
      fill: "url(#om3ricrqmc)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 3648",
    cx: 3.208,
    cy: 3.208,
    r: 3.208,
    transform: "translate(17.234 14.57)",
    style: {
      fill: "url(#37krih9k0d)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 3647",
    cx: 3.208,
    cy: 3.208,
    r: 3.208,
    transform: "translate(17.234 14.57)",
    style: {
      fill: "url(#37krih9k0d)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 41052",
    transform: "translate(57.001 4.514)",
    style: {
      clipPath: "url(#7h4h3heeje)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 14245",
    d: "M284.341 15.16h-1.613a.844.844 0 0 1-.844-.844V.844a.844.844 0 0 1 .844-.844h1.613z",
    transform: "translate(-202.674)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 14246",
    d: "M311.725 15.321h-1.486a.915.915 0 0 1-.823-.516l-5.382-10.274v10.585h-1.674a.782.782 0 0 1-.783-.782V1.013a.782.782 0 0 1 .783-.782h1.75a.915.915 0 0 1 .824.516l5.118 9.729V.231h1.674a.782.782 0 0 1 .782.782v13.525a.782.782 0 0 1-.782.782",
    transform: "translate(-216.833 -.166)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 14247",
    d: "M240.1 9.093h3.779a4.539 4.539 0 0 0 4.573-4.293 4.472 4.472 0 0 0-4.464-4.641h-5.462a.884.884 0 0 0-.884.884v5.1h2.458V2.616h3.819a2.057 2.057 0 0 1 2.076 1.872 2.012 2.012 0 0 1-2.005 2.148h-6.346v8.424h1.573a.884.884 0 0 0 .884-.884z",
    transform: "translate(-170.864 -.114)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 14248",
    d: "M5.839 15.67H.175v-1.543a.914.914 0 0 1 .914-.914h4.79a2 2 0 0 0 2.016-1.818 1.954 1.954 0 0 0-1.948-2.086L4.4 9.3A4.413 4.413 0 0 1 0 4.726 4.48 4.48 0 0 1 4.517.487h5.664V2.03a.914.914 0 0 1-.914.914h-4.79a2 2 0 0 0-2.016 1.818 1.954 1.954 0 0 0 1.948 2.086h1.542a4.413 4.413 0 0 1 4.4 4.579 4.48 4.48 0 0 1-4.512 4.243",
    transform: "translate(0 -.35)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 14249",
    d: "M205.165.627h-8.686V2.1a.981.981 0 0 0 .981.981h2.624V15.4h1.454a1 1 0 0 0 1-1V3.084h3.6V1.608a.981.981 0 0 0-.981-.981",
    transform: "translate(-141.268 -.451)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 14250",
    d: "M57.924.779a1.228 1.228 0 0 0-1.381.644L52.4 9.679l-4.148-8.256a1.229 1.229 0 0 0-2.326.551v12.909a.832.832 0 0 0 .832.832h1.625V7.159l3.355 6.682a.737.737 0 0 0 1.318 0l3.356-6.683v8.557h1.625a.832.832 0 0 0 .832-.832V1.974a1.228 1.228 0 0 0-.945-1.2",
    transform: "translate(-33.021 -.536)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 14251",
    d: "M155.889 9.093h3.779a4.539 4.539 0 0 0 4.574-4.293 4.472 4.472 0 0 0-4.464-4.641h-5.462a.884.884 0 0 0-.884.884v5.1h2.457V2.616h3.819a2.057 2.057 0 0 1 2.076 1.872 2.012 2.012 0 0 1-2.005 2.148h-6.346v8.424H155a.884.884 0 0 0 .884-.884z",
    transform: "translate(-110.317 -.114)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 14252",
    d: "M182.549 30.667a6.929 6.929 0 0 0-.994-1.853 4.463 4.463 0 0 1-2.2 1.191 4.466 4.466 0 0 1 .878 1.483 17.621 17.621 0 0 1 .611 3.385.884.884 0 0 0 .879.789h1.661a23.585 23.585 0 0 0-.836-5",
    transform: "translate(-128.956 -20.717)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 14253",
    d: "M110.478 9.177h-2.56v.011h-5.388l2-6.714h1.387l1.725 5.79h2.56L108 .885a1.228 1.228 0 0 0-1.174-.867h-3.2a1.228 1.228 0 0 0-1.174.867l-4.2 14.073h1.8a1.031 1.031 0 0 0 .988-.737l.768-2.577h6.852l.768 2.577a1.031 1.031 0 0 0 .988.737h1.8z",
    transform: "translate(-70.641 -.013)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 41055"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 41054",
    transform: "translate(57.001 29.514)",
    style: {
      clipPath: "url(#uyswc6verf)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 14254",
    d: "M86.046 2.47V.848A.848.848 0 0 0 85.2 0h-9.386a.848.848 0 0 0-.848.848v13.541a.846.846 0 0 0 .806.844h10.274v-1.616a.848.848 0 0 0-.848-.848h-7.762V8.854h8.039V7.232a.848.848 0 0 0-.848-.848h-7.191V2.47z",
    transform: "translate(-53.897)",
    style: {
      fill: "#ffe500"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 14255",
    d: "M129.368 7.6a4.1 4.1 0 0 0 1.378-2.934A4.5 4.5 0 0 0 126.26 0h-5.49a.889.889 0 0 0-.889.889v4.936h2.47V2.47h3.838a2.068 2.068 0 0 1 2.087 1.882 1.869 1.869 0 0 1-2.016 1.968h-6.379v8.158a.83.83 0 0 0 .83.83h5.5l-.062.015a4.563 4.563 0 0 0 4.6-4.316 4.478 4.478 0 0 0-1.381-3.407m-3.109 5.256h-3.909V8.812h3.841a2.066 2.066 0 0 1 2.08 1.834 2.023 2.023 0 0 1-2.012 2.206",
    transform: "translate(-86.189)",
    style: {
      fill: "#ffe500"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 14256",
    d: "M19.806 0H18a1.036 1.036 0 0 0-.993.74l-2.081 9.891-.975-2.061-3.373-6.717a.763.763 0 0 0-1.35 0L5.855 8.57l-.977 2.061L2.8.74a1.036 1.036 0 0 0-1-.74H0l3.392 13.87a1.232 1.232 0 0 0 .943 1.113c.029.007.058.008.087.013l.044.004a1.205 1.205 0 0 0 .13.011H4.646a1.231 1.231 0 0 0 1.078-.676l4.166-8.3.01-.081.013.084 4.166 8.3a1.232 1.232 0 0 0 1.078.676H15.207a1.2 1.2 0 0 0 .13-.011l.047-.003a.374.374 0 0 0 .087-.013 1.231 1.231 0 0 0 .943-1.113z",
    style: {
      fill: "#ffe500"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLogo);
export default __webpack_public_path__ + "viewer/static/media/menu-logo.1dd953d3e55065fbbb1edf79284045cb.svg";
export { ForwardRef as ReactComponent };